import React from 'react';
import { Bell, FileCheck, AlertTriangle, BookOpen, Clock, BarChart, MessageSquare, Calendar, Info, Settings, Building, Briefcase } from 'lucide-react';
// Örnek Öğretmen Bildirim Verileri
const teacherNotifications = [
// SINAV SONUÇLARI
{
  id: 1,
  type: 'exam_result',
  title: 'LGS Deneme-5 Kurum Sonuçları Açıklandı',
  message: 'Kurum geneli net ortalaması: 68.3. Detaylı analiz için raporlar sayfasını ziyaret edebilirsiniz.',
  time: '2 saat önce',
  read: false,
  priority: 'success' // yeşil
},
// KURUM PERFORMANS UYARISI
{
  id: 2,
  type: 'performance_warning',
  title: 'Türkçe Performansı Uyarısı',
  message: 'Kurum genelinde Türkçe "Fiilimsiler" konusu başarı oranı %45\'e düştü.',
  time: '1 gün önce',
  read: false,
  priority: 'critical' // kırmızı
},
// YENİ SINAV EKLENDİ
{
  id: 3,
  type: 'new_exam',
  title: 'Yeni Deneme Sınavı Eklendi',
  message: 'LGS Deneme-6, 15 Ekim tarihinde tüm 8. sınıflar için aktif olacaktır.',
  time: '2 gün önce',
  read: true,
  priority: 'normal' // yeşil tema
},
// BRANŞ AKTİVİTESİ
{
  id: 4,
  type: 'branch_activity',
  title: 'Matematik Branşına Yeni Soru Eklendi',
  message: '"Veri Analizi" konusuna yüksek zorluk seviyesinde 5 yeni soru eklendi.',
  time: '3 gün önce',
  read: false,
  priority: 'normal'
},
// GENEL DUYURU
{
  id: 5,
  type: 'announcement',
  title: 'Veli Toplantısı Duyurusu',
  message: '2023-2024 Eğitim Yılı 1. Dönem Veli Toplantısı 25 Ekim Pazar günü yapılacaktır.',
  time: '4 gün önce',
  read: true,
  priority: 'normal'
},
// SİSTEM GÜNCELLEMESİ
{
  id: 6,
  type: 'system_update',
  title: 'Platform Güncellemesi',
  message: 'Öğrenci Analizleri sayfasına "Konu Bazlı Gelişim Grafiği" eklendi.',
  time: '1 hafta önce',
  read: true,
  priority: 'normal'
}];
// Bildirim ikonu getiren yardımcı fonksiyon (Öğretmen için güncellendi)
const getNotificationIcon = (type: string) => {
  switch (type) {
    case 'exam_result':
      return <FileCheck className="w-5 h-5 text-emerald-400" data-id="element-1612" />;
    case 'performance_warning':
      return <AlertTriangle className="w-5 h-5 text-red-400" data-id="element-1613" />;
    case 'new_exam':
      return <BookOpen className="w-5 h-5 text-emerald-400" data-id="element-1614" />;
    case 'branch_activity':
      return <Briefcase className="w-5 h-5 text-emerald-400" data-id="element-1615" />;
    case 'announcement':
      return <Building className="w-5 h-5 text-emerald-400" data-id="element-1616" />;
    case 'system_update':
      return <Info className="w-5 h-5 text-gray-400" data-id="element-1617" />;
    default:
      return <Bell className="w-5 h-5 text-gray-400" data-id="element-1618" />;
  }
};
export function OgretmenBildirimler() {
  return <div className="space-y-6" data-id="element-1619">
      {/* Sayfa Başlığı */}
      <div data-id="element-1620">
        <h1 className="text-2xl font-bold" data-id="element-1621">Bildirimler</h1>
        <p className="text-gray-400 text-sm mt-1" data-id="element-1622">
          Kurum ve branşınızla ilgili tüm bildirimler
        </p>
      </div>
      {/* Bildirimler Listesi (Filtresiz) */}
      {teacherNotifications.length > 0 ? <div className="space-y-4" data-id="element-1623">
          {teacherNotifications.map(notification => <div key={notification.id} className={`relative p-[1px] rounded-lg overflow-hidden ${notification.priority === 'critical' ? 'bg-gradient-to-r from-red-500 to-red-600' : notification.priority === 'success' ? 'bg-gradient-to-r from-emerald-500 to-emerald-600' : notification.priority === 'warning' ? 'bg-gradient-to-r from-amber-500 to-amber-600' : 'bg-gradient-to-r from-gray-700 to-gray-800'}`} data-id="element-1624">
              <div className={`relative p-4 bg-black/90 rounded-lg ${!notification.read ? 'border-l-4 border-emerald-500' : ''}`} data-id="element-1625">
                <div className="flex items-start gap-4" data-id="element-1626">
                  {/* İkon */}
                  <div className={`w-10 h-10 rounded-full flex items-center justify-center shrink-0 ${notification.priority === 'critical' ? 'bg-red-500/20' : notification.priority === 'success' ? 'bg-emerald-500/20' : notification.priority === 'warning' ? 'bg-amber-500/20' : 'bg-emerald-500/20'}`} data-id="element-1627">
                    {getNotificationIcon(notification.type)}
                  </div>
                  {/* İçerik */}
                  <div className="flex-1 min-w-0" data-id="element-1628">
                    <div className="flex items-start justify-between gap-2" data-id="element-1629">
                      <h3 className={`font-medium ${!notification.read ? 'text-white font-bold' : 'text-gray-300'}`} data-id="element-1630">
                        {notification.title}
                        {!notification.read && <span className="w-2 h-2 bg-emerald-500 rounded-full inline-block ml-2" data-id="element-1631"></span>}
                      </h3>
                      <span className="text-xs text-gray-500 flex-shrink-0" data-id="element-1632">
                        {notification.time}
                      </span>
                    </div>
                    <p className={`text-sm mt-1 ${!notification.read ? 'text-gray-300' : 'text-gray-400'}`} data-id="element-1633">
                      {notification.message}
                    </p>
                  </div>
                </div>
              </div>
            </div>)}
        </div> :
    // Boş durum
    <div className="text-center py-12" data-id="element-1634">
          <Bell className="w-16 h-16 text-gray-600 mx-auto mb-4" data-id="element-1635" />
          <h3 className="text-lg font-medium text-gray-400 mb-2" data-id="element-1636">
            Henüz bildirim bulunmuyor
          </h3>
          <p className="text-gray-500" data-id="element-1637">
            Yeni kurumsal bildirimler burada görünecek
          </p>
        </div>}
    </div>;
}